import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/imports/history')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('orders:write')) {
      throw redirect({ to: '/' });
    }
  },
  // The `feat-file-import` guard lives in useImportHistoryPage() (component) rather than here — see
  // the same rationale comment in `routes/_authenticated/imports/index.tsx`.
  component: lazyRouteComponent(() => import('&/features/imports/pages/import-history-page')),
});
